import { SCHEMA } from '@vedalib/editor/lib/brand'
import { useCallback, useMemo } from 'react'
import React from 'react'

import { Typography } from 'components/uiKit/Typography'
import { BrandFormFontBase, BrandGoBack } from 'services/Branding/components'
import { FONT_FIELDS } from 'services/Branding/fieldConfigs'
import { genSchema } from 'services/Branding/genSchema'
import { useUpdateSchema } from 'services/Branding/hooks'
import { BrandFormEnum } from 'services/Branding/types'
import { t } from 'services/Translation'

import type { CourseProgressFormBrandType } from './courseProgressTypes'

const FONT_FORM_SCHEMA = genSchema(SCHEMA.courseProgress.font, { base: FONT_FIELDS.base })

const CourseProgressFormFont: CourseProgressFormBrandType = ({ device, setForm, subConfigs }) => {
  const path = useMemo(() => ['font', device], [device])
  const schema = useUpdateSchema(path, subConfigs, FONT_FORM_SCHEMA)

  const handleSetStyle = useCallback(() => setForm(BrandFormEnum.STYLE), [setForm])

  return (
    <BrandFormFontBase font={schema.base}>
      <BrandGoBack onClick={handleSetStyle}>
        <Typography weight='medium'>{t('elements.courseProgress.tags.text')}</Typography>
      </BrandGoBack>
      <Typography styleType='hint'>{t('page.brand.fonts.inheritHint')}</Typography>
    </BrandFormFontBase>
  )
}

export default React.memo(CourseProgressFormFont) as typeof CourseProgressFormFont
